import { I18n } from "aws-amplify";
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Skeleton } from 'primereact/skeleton';
import React, { useContext, useEffect, useRef, useState } from "react";
import { deleteMailingTarget, getMailingTarget } from "../../../service/ScrbService";
import { StructureContext } from "../../../structure-context";
import PropTypes from 'prop-types';
import { Messages } from 'primereact/messages';
import { useMountEffect } from 'primereact/hooks';
import { Card } from "primereact/card";
import AddContactDialog from "./AddContactDialog";

Contacts.propTypes = {
    informations: PropTypes.object.isRequired,
    showNotif: PropTypes.func
};

export default function Contacts(props) {

    const structureId = useContext(StructureContext).id;
    const [mailingTargets, setMailingTargets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showAddContact, setShowAddContact] = useState(false);

    const msgs = useRef(null);

    useMountEffect(() => {
        if (msgs.current) {
            msgs.current.clear();
            msgs.current.show([
                { sticky: true, severity: 'warn', summary: I18n.get("warning"), detail: I18n.get("noContact"), closable: false },
            ]);
        }
    });

    useEffect(() => {
        if (structureId)
            loadMailingTargets();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [structureId]);

    useEffect(() => {
        if (mailingTargets.length > 0)
            setLoading(false);
    }, [mailingTargets]);

    const loadMailingTargets = () => {
        setLoading(true);
        getMailingTarget(structureId).then(targets => {
            setMailingTargets(targets.sort((a, b) => a.name.localeCompare(b.name)));
            setLoading(false);
            if (targets.length === 0) {
                setShowAddContact(true);
            }
        });
    }

    const deleteMailing = async (target) => {
        target.structureId = structureId;
        setLoading(true);
        try {
            const res = await deleteMailingTarget(target);
            if (res.statusCode === 200) {
                loadMailingTargets();
                props.showNotif("success", I18n.get("success"), I18n.get("contactDeleted"));
            }
            else {
                props.showNotif("error", I18n.get("unauthorized"), I18n.get("contactNotDeleted"));
            }
        } catch (error) {
            props.showNotif("error", I18n.get("error"), I18n.get("contactNotDeleted"));
        }
        setLoading(false);
    }

    const confirmDelete = (target) => {
        confirmDialog({
            message: I18n.get("confirmRemoveContact"),
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            acceptLabel: I18n.get("delete"),
            rejectLabel: I18n.get("cancel"),
            accept: () => { deleteMailing(target) }
        });
    };

    const contactScrb = () => {
        return <div className="flex flex-row p-3 gap-3 w-full">
            {props.informations.contacts.sort((a, b) => a.ordre - b.ordre).map(contact => {
                return <Card
                    className="flex flex-column w-20rem"
                    key={contact.ordre}
                    title={<div className="flex justify-content-center text-lg">{contact.nom}</div>}
                >
                    <div className="flex flex-column align-items-center">
                        <img src={contact.photo} alt={contact.nom} className="w-10rem h-10rem mb-3" />
                        <div className="flex justify-content-center text-md pb-3">{contact.poste}</div>
                        <div className="flex justify-content-center text-sm"><span className="pi pi-phone">&nbsp;</span> {contact.telephone}</div>
                        <div className="flex justify-content-center text-sm pb-3"><span className="pi pi-envelope">&nbsp;</span> {contact.email}</div>
                        {contact.competences.map(competence => {
                            return <div key={competence} className="flex justify-content-center text-sm">{competence}</div>
                        })}
                    </div>
                </Card>
            })}
        </div>
    }

    return <>
        {<ConfirmDialog />}
        {contactScrb()}
        <div className="text-xl">{I18n.get("addressDeContact")}&nbsp;:</div>
        {mailingTargets.length === 0 && <Messages ref={msgs} />}
        <div className="flex flex-column">
            <div className="flex flex-wrap w-10 gap-3 pt-4">
                {loading && [...Array(3)].map((_, index) => (
                    <Skeleton key={index} width="10rem" height="10rem" />
                ))}
                {!loading && mailingTargets.map(target => {
                    return <div className="p-3 border-1 border-round-xl border-300 relative" key={target.id}>
                        {mailingTargets.length > 1 && <Button
                            onClick={() => confirmDelete(target)}
                            icon="pi pi-trash"
                            outlined
                            rounded
                            severity="danger"
                            style={{ position: 'absolute', top: '0.5rem', right: '0.5rem', scale: '0.8' }}
                        />
                        }
                        <div className="flex justify-content-center w-15rem align-items-center">
                            <span style={{ fontSize: "3rem" }}><i className="fa-light fa-user-group"></i></span>
                        </div>
                        <div className="text-center">{target.name}</div>
                    </div>
                })}
            </div>
            <div className="flex flex-column gap-2 pt-4">
                <AddContactDialog
                    visible={showAddContact}
                    onHide={() => setShowAddContact(false)}
                    onAdded={loadMailingTargets}
                    showNotif={props.showNotif}
                />
                <Button
                    label={I18n.get("add")}
                    icon="pi pi-plus"
                    onClick={() => setShowAddContact(true)}
                    outlined
                    className="justify-content-center w-full lg:w-10rem"
                />
            </div>
        </div>
    </>;
}
